/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { JobOccurrenceDtoTargetSystem } from './JobOccurrenceDtoTargetSystem';
import {
    JobOccurrenceDtoTargetSystemFromJSON,
    JobOccurrenceDtoTargetSystemFromJSONTyped,
    JobOccurrenceDtoTargetSystemToJSON,
} from './JobOccurrenceDtoTargetSystem';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { QaEquipmentCatalogDto } from './QaEquipmentCatalogDto';
import {
    QaEquipmentCatalogDtoFromJSON,
    QaEquipmentCatalogDtoFromJSONTyped,
    QaEquipmentCatalogDtoToJSON,
} from './QaEquipmentCatalogDto';
import type { ProtocolDto } from './ProtocolDto';
import {
    ProtocolDtoFromJSON,
    ProtocolDtoFromJSONTyped,
    ProtocolDtoToJSON,
} from './ProtocolDto';
import type { RoleCatalogDto } from './RoleCatalogDto';
import {
    RoleCatalogDtoFromJSON,
    RoleCatalogDtoFromJSONTyped,
    RoleCatalogDtoToJSON,
} from './RoleCatalogDto';
import type { DueState } from './DueState';
import {
    DueStateFromJSON,
    DueStateFromJSONTyped,
    DueStateToJSON,
} from './DueState';
import type { JobFrequency } from './JobFrequency';
import {
    JobFrequencyFromJSON,
    JobFrequencyFromJSONTyped,
    JobFrequencyToJSON,
} from './JobFrequency';
import type { JobState } from './JobState';
import {
    JobStateFromJSON,
    JobStateFromJSONTyped,
    JobStateToJSON,
} from './JobState';
import type { WorkItemDto } from './WorkItemDto';
import {
    WorkItemDtoFromJSON,
    WorkItemDtoFromJSONTyped,
    WorkItemDtoToJSON,
} from './WorkItemDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { JobOccurrenceDtoWorkProgressSummary } from './JobOccurrenceDtoWorkProgressSummary';
import {
    JobOccurrenceDtoWorkProgressSummaryFromJSON,
    JobOccurrenceDtoWorkProgressSummaryFromJSONTyped,
    JobOccurrenceDtoWorkProgressSummaryToJSON,
} from './JobOccurrenceDtoWorkProgressSummary';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';

/**
 * 
 * @export
 * @interface JobOccurrenceDto
 */
export interface JobOccurrenceDto {
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof JobOccurrenceDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof JobOccurrenceDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobOccurrenceDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobOccurrenceDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobOccurrenceDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof JobOccurrenceDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof JobOccurrenceDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof JobOccurrenceDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {JobState}
     * @memberof JobOccurrenceDto
     */
    state?: JobState;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    jobConfigurationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    jobConfigurationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    jobConfigurationIuid?: string | null;
    /**
     * 
     * @type {JobFrequency}
     * @memberof JobOccurrenceDto
     */
    frequency?: JobFrequency;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceDto
     */
    assignedUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceDto
     */
    assignedRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    assignedUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    assignedRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOccurrenceDto
     */
    assignedRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    reviewRequired?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceDto
     */
    reviewUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceDto
     */
    reviewRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    reviewUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    reviewRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOccurrenceDto
     */
    reviewRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    autoApprove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    wasAutoApproved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    approvalTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceDto
     */
    approverUserId?: number | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceDto
     */
    approverUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    targetSystemId?: string | null;
    /**
     * 
     * @type {JobOccurrenceDtoTargetSystem}
     * @memberof JobOccurrenceDto
     */
    targetSystem?: JobOccurrenceDtoTargetSystem | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    timeZone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceDto
     */
    executionAllDay?: boolean;
    /**
     * 
     * @type {DueState}
     * @memberof JobOccurrenceDto
     */
    dueState?: DueState;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    executionStarted?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    executionCompleted?: string | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceDto
     */
    executionCompletedByUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    executionStateChangedTime?: string | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceDto
     */
    executionStateChangedUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {JobOccurrenceDtoWorkProgressSummary}
     * @memberof JobOccurrenceDto
     */
    workProgressSummary?: JobOccurrenceDtoWorkProgressSummary | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    jobConfigurationDescription?: string | null;
    /**
     * 
     * @type {Array<QaEquipmentCatalogDto>}
     * @memberof JobOccurrenceDto
     */
    supportSystems?: Array<QaEquipmentCatalogDto> | null;
    /**
     * 
     * @type {Array<WorkItemDto>}
     * @memberof JobOccurrenceDto
     */
    workItems?: Array<WorkItemDto> | null;
    /**
     * 
     * @type {Array<ProtocolDto>}
     * @memberof JobOccurrenceDto
     */
    protocols?: Array<ProtocolDto> | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceDto
     */
    $type?: JobOccurrenceDtoTypeEnum;
}


/**
 * @export
 */
export const JobOccurrenceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoJobOccurrenceDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.JobOccurrenceDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type JobOccurrenceDtoTypeEnum = typeof JobOccurrenceDtoTypeEnum[keyof typeof JobOccurrenceDtoTypeEnum];



/**
 * Check if a given object implements the JobOccurrenceDto interface.
 */
export function instanceOfJobOccurrenceDto(value?: unknown): value is JobOccurrenceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(JobOccurrenceDtoTypeEnum)[0];
}

export function JobOccurrenceDtoFromJSON(json: any): JobOccurrenceDto {
    return JobOccurrenceDtoFromJSONTyped(json, false);
}

export function JobOccurrenceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOccurrenceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': json['state'] == null ? undefined : JobStateFromJSON(json['state']),
        'jobConfigurationId': json['jobConfigurationId'] == null ? undefined : json['jobConfigurationId'],
        'jobConfigurationName': json['jobConfigurationName'] == null ? undefined : json['jobConfigurationName'],
        'jobConfigurationIuid': json['jobConfigurationIuid'] == null ? undefined : json['jobConfigurationIuid'],
        'frequency': json['frequency'] == null ? undefined : JobFrequencyFromJSON(json['frequency']),
        'assignedUserIds': json['assignedUserIds'] == null ? undefined : json['assignedUserIds'],
        'assignedRoleIds': json['assignedRoleIds'] == null ? undefined : json['assignedRoleIds'],
        'assignedUsers': json['assignedUsers'] == null ? undefined : ((json['assignedUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'assignedRoles': json['assignedRoles'] == null ? undefined : ((json['assignedRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'assignedRolesDisplayNames': json['assignedRolesDisplayNames'] == null ? undefined : json['assignedRolesDisplayNames'],
        'reviewRequired': json['reviewRequired'] == null ? undefined : json['reviewRequired'],
        'reviewUserIds': json['reviewUserIds'] == null ? undefined : json['reviewUserIds'],
        'reviewRoleIds': json['reviewRoleIds'] == null ? undefined : json['reviewRoleIds'],
        'reviewUsers': json['reviewUsers'] == null ? undefined : ((json['reviewUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'reviewRoles': json['reviewRoles'] == null ? undefined : ((json['reviewRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'reviewRolesDisplayNames': json['reviewRolesDisplayNames'] == null ? undefined : json['reviewRolesDisplayNames'],
        'autoApprove': json['autoApprove'] == null ? undefined : json['autoApprove'],
        'wasAutoApproved': json['wasAutoApproved'] == null ? undefined : json['wasAutoApproved'],
        'approvalTime': json['approvalTime'] == null ? undefined : json['approvalTime'],
        'approverUserId': json['approverUserId'] == null ? undefined : json['approverUserId'],
        'approverUser': json['approverUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['approverUser']),
        'targetSystemId': json['targetSystemId'] == null ? undefined : json['targetSystemId'],
        'targetSystem': json['targetSystem'] == null ? undefined : JobOccurrenceDtoTargetSystemFromJSON(json['targetSystem']),
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'executionAllDay': json['executionAllDay'] == null ? undefined : json['executionAllDay'],
        'dueState': json['dueState'] == null ? undefined : DueStateFromJSON(json['dueState']),
        'executionStarted': json['executionStarted'] == null ? undefined : json['executionStarted'],
        'executionCompleted': json['executionCompleted'] == null ? undefined : json['executionCompleted'],
        'executionCompletedByUser': json['executionCompletedByUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['executionCompletedByUser']),
        'executionStateChangedTime': json['executionStateChangedTime'] == null ? undefined : json['executionStateChangedTime'],
        'executionStateChangedUser': json['executionStateChangedUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['executionStateChangedUser']),
        'workProgressSummary': json['workProgressSummary'] == null ? undefined : JobOccurrenceDtoWorkProgressSummaryFromJSON(json['workProgressSummary']),
        'jobConfigurationDescription': json['jobConfigurationDescription'] == null ? undefined : json['jobConfigurationDescription'],
        'supportSystems': json['supportSystems'] == null ? undefined : ((json['supportSystems'] as Array<any>).map(QaEquipmentCatalogDtoFromJSON)),
        'workItems': json['workItems'] == null ? undefined : ((json['workItems'] as Array<any>).map(WorkItemDtoFromJSON)),
        'protocols': json['protocols'] == null ? undefined : ((json['protocols'] as Array<any>).map(ProtocolDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function JobOccurrenceDtoToJSON(value?: Omit<JobOccurrenceDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': JobStateToJSON(value['state']),
        'jobConfigurationId': value['jobConfigurationId'],
        'jobConfigurationName': value['jobConfigurationName'],
        'jobConfigurationIuid': value['jobConfigurationIuid'],
        'frequency': JobFrequencyToJSON(value['frequency']),
        'assignedUserIds': value['assignedUserIds'],
        'assignedRoleIds': value['assignedRoleIds'],
        'assignedUsers': value['assignedUsers'] == null ? undefined : ((value['assignedUsers'] as Array<any>).map(UserCatalogDtoToJSON)),
        'assignedRoles': value['assignedRoles'] == null ? undefined : ((value['assignedRoles'] as Array<any>).map(RoleCatalogDtoToJSON)),
        'assignedRolesDisplayNames': value['assignedRolesDisplayNames'],
        'reviewRequired': value['reviewRequired'],
        'reviewUserIds': value['reviewUserIds'],
        'reviewRoleIds': value['reviewRoleIds'],
        'reviewUsers': value['reviewUsers'] == null ? undefined : ((value['reviewUsers'] as Array<any>).map(UserCatalogDtoToJSON)),
        'reviewRoles': value['reviewRoles'] == null ? undefined : ((value['reviewRoles'] as Array<any>).map(RoleCatalogDtoToJSON)),
        'reviewRolesDisplayNames': value['reviewRolesDisplayNames'],
        'autoApprove': value['autoApprove'],
        'wasAutoApproved': value['wasAutoApproved'],
        'approvalTime': value['approvalTime'],
        'approverUserId': value['approverUserId'],
        'approverUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['approverUser']),
        'targetSystemId': value['targetSystemId'],
        'targetSystem': JobOccurrenceDtoTargetSystemToJSON(value['targetSystem']),
        'start': value['start'],
        'end': value['end'],
        'timeZone': value['timeZone'],
        'executionAllDay': value['executionAllDay'],
        'dueState': DueStateToJSON(value['dueState']),
        'executionStarted': value['executionStarted'],
        'executionCompleted': value['executionCompleted'],
        'executionCompletedByUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['executionCompletedByUser']),
        'executionStateChangedTime': value['executionStateChangedTime'],
        'executionStateChangedUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['executionStateChangedUser']),
        'workProgressSummary': JobOccurrenceDtoWorkProgressSummaryToJSON(value['workProgressSummary']),
        'jobConfigurationDescription': value['jobConfigurationDescription'],
        'supportSystems': value['supportSystems'] == null ? undefined : ((value['supportSystems'] as Array<any>).map(QaEquipmentCatalogDtoToJSON)),
        'workItems': value['workItems'] == null ? undefined : ((value['workItems'] as Array<any>).map(WorkItemDtoToJSON)),
        'protocols': value['protocols'] == null ? undefined : ((value['protocols'] as Array<any>).map(ProtocolDtoToJSON)),
        '$type': value['$type'],
    });
}

